import {
  Box,
  Button,
  Dialog,
  Stack,
  Typography,
} from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { useTranslation } from "react-i18next";
import {
  SUPPORTED_LANGUAGES,
  normalizeToSupportedLanguage,
} from "../../i18n/config";

const LanguageDialog = ({ open, onClose }) => {
  const { t, i18n } = useTranslation();
  const activeLanguage = normalizeToSupportedLanguage(
    i18n.resolvedLanguage || i18n.language
  );

  const handleLanguageChange = async (languageCode) => {
    if (languageCode === activeLanguage) {
      onClose?.();
      return;
    }

    await i18n.changeLanguage(languageCode);
    onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      sx={{
        "& .MuiPaper-root.MuiDialog-paper": {
          background: "#111218 !important",
          backgroundColor: "#111218 !important",
          borderRadius: "5px",
          backgroundImage: "none",
          overflow: "hidden",
          boxShadow: "0 18px 48px rgba(0,0,0,0.42)",
          margin: "16px",
        },
      }}
      PaperProps={{
        elevation: 0,
        sx: {
          background: "#111218 !important",
          backgroundColor: "#111218 !important",
          borderRadius: "5px",
          backgroundImage: "none",
          overflow: "hidden",
          boxShadow: "0 18px 48px rgba(0,0,0,0.42)",
        },
      }}
    >
      <Box sx={{ p: 2.2, backgroundColor: "#111218", borderRadius: "5px" }}>
        <Stack spacing={1.6}>
          <Typography
            className="teko-title"
            sx={{ color: "#fff", fontWeight: 900, fontSize: "1.1rem" }}
          >
            {t("languageDialog.title")}
          </Typography>
          <Typography sx={{ color: "#d7dae3", fontSize: "0.92rem", lineHeight: 1.55 }}>
            {t("languageDialog.description")}
          </Typography>

          <Stack spacing={1}>
            {SUPPORTED_LANGUAGES.map((language) => {
              const isActive = language.code === activeLanguage;

              return (
                <Button
                  key={language.code}
                  onClick={() => handleLanguageChange(language.code)}
                  sx={{
                    justifyContent: "space-between",
                    textTransform: "none",
                    borderRadius: "5px",
                    color: "#fff",
                    backgroundColor: isActive
                      ? "rgba(255,219,66,0.14)"
                      : "rgba(255,255,255,0.04)",
                    border: isActive
                      ? "1px solid rgba(255,219,66,0.55)"
                      : "1px solid rgba(255,255,255,0.08)",
                    px: 1.4,
                    py: 1.1,
                    "&:hover": {
                      backgroundColor: isActive
                        ? "rgba(255,219,66,0.18)"
                        : "rgba(255,255,255,0.08)",
                    },
                  }}
                >
                  <span className="teko-button-text">
                    {t(`languages.${language.code}`)}
                  </span>
                  {isActive ? (
                    <CheckRoundedIcon sx={{ color: "#ffdb42", fontSize: 20 }} />
                  ) : null}
                </Button>
              );
            })}
          </Stack>

          <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 0.4 }}>
            <Button
              onClick={onClose}
              sx={{
                textTransform: "none",
                borderRadius: "5px",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.14)",
              }}
            >
              <span className="teko-button-text">{t("languageDialog.close")}</span>
            </Button>
          </Box>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default LanguageDialog;
